<template>
  <Modal :width="513" @modalClose="modalClose">
    <div class="modal-inner">
      <p class="modal-title">Welcome!</p>
      <p class="modal-description">
        You have earned 4 Pixtokens. Connect your wallet to start minting your
        NFTs.
      </p>
      <svg
        class="modal-icon"
        width="101"
        height="90"
        viewBox="0 0 101 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g filter="url(#filter0_d_9120_42454)">
          <path
            d="M56.5712 76C69.5892 76 80.1424 65.7025 80.1424 53C80.1424 40.2975 69.5892 30 56.5712 30C43.5532 30 33 40.2975 33 53C33 65.7025 43.5532 76 56.5712 76Z"
            fill="#34A3E6"
          />
          <path
            d="M74.9085 52.7031C74.9085 62.8282 66.7005 71.0363 56.5753 71.0363C46.4502 71.0363 38.2422 62.8282 38.2422 52.7031"
            stroke="#84CCF8"
            stroke-width="1.5"
          />
          <path
            d="M56.5753 71.0363C46.4502 71.0363 38.2422 62.8282 38.2422 52.7031"
            stroke="#E4F1FA"
            stroke-width="1.5"
          />
          <path
            d="M74.9085 53.5753C74.9085 43.4502 66.7005 35.2422 56.5753 35.2422C46.4502 35.2422 38.2422 43.4502 38.2422 53.5753"
            stroke="#034166"
            stroke-width="1.5"
          />
          <path
            d="M74.9113 53.5753C74.9113 43.4502 66.7032 35.2422 56.5781 35.2422"
            stroke="#034166"
            stroke-width="1.5"
          />
          <path
            d="M45.2188 45.7188H47.2157L50.341 53.0281V45.7188H52.7197V59.7818H50.7923L47.6663 52.0041V59.7825H45.2188V45.7188Z"
            fill="white"
          />
          <path
            d="M54.8359 45.7188H60.7735V47.6809H57.683V51.4662H60.3044V53.4624H57.683V59.7825H54.8359V45.7188Z"
            fill="url(#paint0_linear_9120_42454)"
          />
          <path
            d="M63.5373 47.837H61.3672V45.7188H68.5552V47.837H66.4199V59.7825H63.538V47.837H63.5373Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter1_d_9120_42454)">
          <path
            d="M66.5712 71C79.5892 71 90.1424 60.7025 90.1424 48C90.1424 35.2975 79.5892 25 66.5712 25C53.5532 25 43 35.2975 43 48C43 60.7025 53.5532 71 66.5712 71Z"
            fill="#34A3E6"
          />
          <path
            d="M84.9085 47.7031C84.9085 57.8282 76.7005 66.0363 66.5753 66.0363C56.4502 66.0363 48.2422 57.8282 48.2422 47.7031"
            stroke="#84CCF8"
            stroke-width="1.5"
          />
          <path
            d="M66.5753 66.0363C56.4502 66.0363 48.2422 57.8282 48.2422 47.7031"
            stroke="#E4F1FA"
            stroke-width="1.5"
          />
          <path
            d="M84.9085 48.5753C84.9085 38.4502 76.7005 30.2422 66.5753 30.2422C56.4502 30.2422 48.2422 38.4502 48.2422 48.5753"
            stroke="#034166"
            stroke-width="1.5"
          />
          <path
            d="M84.9113 48.5753C84.9113 38.4502 76.7032 30.2422 66.5781 30.2422"
            stroke="#034166"
            stroke-width="1.5"
          />
          <path
            d="M55.2188 40.7188H57.2157L60.341 48.0281V40.7188H62.7197V54.7818H60.7923L57.6663 47.0041V54.7825H55.2188V40.7188Z"
            fill="white"
          />
          <path
            d="M64.8359 40.7188H70.7735V42.6809H67.683V46.4662H70.3044V48.4624H67.683V54.7825H64.8359V40.7188Z"
            fill="url(#paint1_linear_9120_42454)"
          />
          <path
            d="M73.5373 42.837H71.3672V40.7188H78.5552V42.837H76.4199V54.7825H73.538V42.837H73.5373Z"
            fill="white"
          />
        </g>
        <rect width="75" height="73" fill="url(#pattern0)" />
        <rect
          width="51"
          height="51"
          transform="matrix(1 0 0 -1 25 74)"
          fill="url(#pattern1)"
        />
        <defs>
          <filter
            id="filter0_d_9120_42454"
            x="23"
            y="24"
            width="67.1406"
            height="66"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.172549 0 0 0 0 0.568627 0 0 0 0 0.701961 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_9120_42454"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_9120_42454"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_9120_42454"
            x="33"
            y="19"
            width="67.1406"
            height="66"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.172549 0 0 0 0 0.568627 0 0 0 0 0.701961 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_9120_42454"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_9120_42454"
              result="shape"
            />
          </filter>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlink:href="#image0_9120_42454"
              transform="matrix(0.00277778 0 0 0.00285388 0 -0.0136986)"
            />
          </pattern>
          <pattern
            id="pattern1"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlink:href="#image0_9120_42454"
              transform="scale(0.00277778)"
            />
          </pattern>
          <linearGradient
            id="paint0_linear_9120_42454"
            x1="43.7735"
            y1="66.3839"
            x2="72.9931"
            y2="34.4797"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_9120_42454"
            x1="53.7735"
            y1="61.3839"
            x2="82.9931"
            y2="29.4797"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
          <image
            id="image0_9120_42454"
            width="360"
            height="360"
            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWgAAAFoCAYAAAB65WHVAAAAAXNSR0IArs4c6QAAFgpJREFUeF7t3T2M3HeZB/Dfzu7szq692Gujs7lLeLGjKIbowglxKSIdoCtBugauokCnNDSpopNCQUEBEkpFQxMhChpiyqOgInfoilxAitEJowibBHIhhrM3vl3v++7/9NtoHL/sy+zrPDPPx00KZmee5/M8/y+j//znPyPFPwIECBAIKTASsipFESBAgEAR0JaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyy4gpcfeWF5tLnv+PYiTuioanMkg3NKDVyHAJv/+e/NKfHb5QbixfLxX/4nuPnONATv4YFSzx8re9dYP61LzaTI7NlYexCKdPPlOmLX3cM7Z3RX/QoYLl6hPIwAktvfKMZXb1SRhdvlKaMl4X2J8v0Uy85hqzGkQlYriOj9cTDJnDr1S83p0bfKSNlZbO1heZcac58ybvoYRt0oH4EdKBhKCWuwNJvn2vW566WzsiduwG92MyU2ZVHyyPP/MBxFHd0A12ZxRro8Sn+OARm37zcTM5fLu2lt++Gc33depqjhvTIzNPlxGPfdCwdxzCSvYalSjZw7e5dYO7Ks01r5a1SPxys/5bHxsvE2vunOWpIr3YeKZ0nX3Ys7Z3WX+wiYKmsCIEdBO787ltNM/tqGW8tlbHm9paPrO+i31285LI7m3ToAgL60Ek94TAJ1A8GT47NltFmcbOt7geE9/bYPdXROvO5MnXxXx1Tw7QAfe7FMvV5AF4+rsDC9eeb9uLVzcvquqcztgvo9ZHJMr82U848/RPHVNyRDlxllmngRqbg4xDohnNrcfbuu+b6TnmrgO6G98bkTLnx3jlXdRzHgJK8hoBOMmht9i4wd+37TXvx51tetbFdQHdDup6Pbp29VKYuvOjY6p3cI7cRsERWg8A9AjWcR2792+YVGzuF8b1oGxNNaS2/fyh1r+pYnfyCL7DYrAMLCOgDE3qCYRKYe/2rzdTa9W3D+d4w3i6k10ZOleWxT5Ry8jNCepiWow+9COg+oHvJmAIPXu+8XRhvV333HHX970oZK2tjHy1rp/+pzHz8K46zmCMPX5XFCT8iBR6HQL2N6Mz4H+/7KvdeXreGcvdf99TIcpkqN5cf86HhXiA99j4BAW0h0gvU+2yszV27+03BB4P2QaCtruboBvSD563rh4Yb7XPeSaffsv0BCOj9ufmrIRHontbo3gRpq3fCvQb0dh8qOic9JMvShzYEdB/QvWT/BRaufbdpLf6ytJZvbvkV7l6Cutcu6nMtNSc230m3O2dK5wm/xNKrXfbHCejsG5Cw/3rj/bXbV8royFwZL2s7fvmk10vtemGsQe3LLL1IecwHp9lYEEgkUD8MPHf6RllZWNn3B4K9nPLYjvTed9N+MivR4u2zVe+g9wnnzwZLoJ7SWJ9/o0ys/X7bu9Ltp6Odvv5dn2+rDw+7l+GNdM6XMv5Y6Tz+bcfhfvAT/I3FSDDkzC3WbwaW+V+V9uj/bXu+uV8+976bbp183E3/+zWIwK8roAMPR2n7F6i/gnLrD78of3Pm3c1grrcLvfd88l6/hLL/Snb/y/oDAGPt92+0dOr8Z337cHeyNI8Q0GlGnaPR7jvm1aX3yvTJxdIsLT0UztEkakCPr5VSb1m6stEpTXumjE7/rXtLRxtUH+oR0H1A95JHI1B//WT55q/LROv23Q8AdztHfDSVvH/uebcrQLb7ckv3hkv/c+u8X2k5qgENyPMK6AEZlDJ3F7j6ygvNoyd+fd+d6HoJyt2fee+P2Cl8t7vpf32V+r91f6HlvRX3lt67/HD9hYAernmm76Ze47ww+8bm6Y2dLqW794dfjwptL//n0P3AcHxqvMzNT5Z253SZfuolx+dRDWdAntcCDMiglLk3gXou+va7r5V6A6Tur3Hv7RmO99H1nh2zK4+WM+efcO75eOlDv5qADj0exR1UoN4IaeH2OyE/MOy+ax6dnCmr6x/yjvmgwx7CvxfQQzhULT0scO0/nmvqJXftpbd3/fDuOPycZz4O5cF/DQE9+DPUwR4E6i+mTKz/qW+X3nXfNdf/jp16yrcI9zC7jA8V0Bmnnrzn+m76o2evle4vdh/0znV7+TBw8/7Q4x9zOiP5DvbavoDuVcrjhkqgXjPdzL5axlvvf5Gl/ute4rbb9csPQvQS0He/1i2ch2qPjroZAX3Uwp4/rEC9gdLGrX/fvMqjfovvwa+DH1bh9Yb982szpfPhv3eFxmGhJnkeAZ1k0NrcXqCel26t3tj89mH3nfRheNV3zTX4azifefonjrXDQE32HJYm2cC1u7VA90dje7lmertTGg/egKk+7vb6X5f2h//RDZAs3r4EBPS+2PzRMAp0r/AYa24fuL3uaQ3hfGDK1E8goFOPX/MPCtSQnlq7vu9rpe89reGcs/06qICAPqigvx8qgfrB4dL//lc5OTa7r19e6X4BpXXmcz4QHKrN6E8zAro/7l41sMC9V3fs5UPDu1/dnr7kl7sDz3eQShPQgzQttR6bQPeXv+uHhr1eF13POy+PfqRMf/pHjqtjm9Rwv5BFGu756u4AAr1e2dG9qmOlc6F0nnzZMXUAc396v4BlshEEdhCYf+2LzW7vomtAb9Q70k1eKlMXXnRM2ahDE7BMh0bpiYZRYOH680178WoZXbyxbXv11Maflz5WHnnmB46nYVyCPvZkofqI76UHQ6Ce6virzlsPXdXRvclSvQHSyc/+1LE0GOMcqCot1UCNS7H9EJh983LT/ssPy9TI/e+i715Sd9apjX7MJcNrCugMU9bjgQXmrjzbTK3+ZvN5uld1LJepcnP5Mac2DqzrCbYTENB2g0CPAg9+y3B98lxZ7fhCSo98HrYPAQG9DzR/klOgfmDY3LyyeXvS7o2Q3KUu5y4cV9cC+rikvc5QCNx69cvNqdF3Sv1g0E9WDcVIQzchoEOPR3HRBOoVHadOrJTbd8ade442nCGsR0AP4VC1dLQCV195obn0+e84do6W2bNvfiDtHwECBAiEFBDQIceiKAIECHgHbQcIECAQVsA76LCjURgBAtkFBHT2DdA/AQJhBQR02NEojACB7AICOvsG6J8AgbACAjrsaBRGgEB2AQGdfQP0T4BAWAEBHXY0CiNAILuAgM6+AfonQCCsgIAOOxqFESCQXUBAZ98A/RMgEFZAQIcdjcIIEMguIKCzb4D+CRAIKyCgw45GYQQIZBcQ0Nk3QP8ECIQVENBhR6MwAgSyCwjo7BugfwIEwgoI6LCjURgBAtkFBHT2DdA/AQJhBQR02NEojACB7AICOvsG6J8AgbACAjrsaBRGgEB2AQGdfQP0T4BAWAEBHXY0CiNAILuAgM6+AfonQCCsgIAOOxqFESCQXUBAZ98A/RMgEFZAQIcdjcIIEMguIKCzb4D+CRAIKyCgw45GYQQIZBcQ0Nk3QP8ECIQVENBhR6MwAgSyCwjo7BugfwIEwgoI6LCjURgBAtkFBHT2DdA/AQJhBQR02NEojACB7AICOvsG6J8AgbACAjrsaBRGgEB2AQGdfQP0T4BAWAEBHXY0CiNAILuAgM6+AfonQCCsgIAOOxqFESCQXUBAZ98A/RMgEFZAQIcdjcIIEMguIKCzb4D+CRAIKyCgw45GYQQIZBcQ0Nk3QP8ECIQVENBhR6MwAgSyCwjo7BugfwIEwgoI6LCjURgBAtkFBHT2DdA/AQJhBQR02NEojACB7AICOvsG6J8AgbACAjrsaBRGgEB2AQGdfQP0T4BAWAEBHXY0CiNAILuAgM6+AfonQCCsgIAOOxqFESCQXUBAZ98A/RMgEFZAQIcdjcIIEMguIKCzb4D+CRAIKyCgw45GYQQIZBcQ0Nk3QP8ECIQVENBhR6MwAgSyCwjo7BugfwIEwgoI6LCjURgBAtkFBHT2DdA/AQJhBQR02NEojACB7AICOvsG6J8AgbACAjrsaBRGgEB2AQGdfQP0T4BAWAEBHXY0CiNAILuAgM6+AfonQCCsgIAOOxqFESCQXUBAZ98A/RMgEFZAQIcdjcIIEMguIKCzb4D+CRAIKyCgw45GYQQIZBcQ0Nk3QP8ECIQVENBhR6MwAgSyCwjo7BugfwIEwgoI6LCjURgBAtkFBHT2DdA/AQJhBQR02NEojACB7AICOvsG6J8AgbACAjrsaBRGgEB2AQGdfQP0T4BAWAEBHXY0CiNAILuAgM6+AfonQCCsgIAOOxqFESCQXUBAZ98A/RMgEFZAQIcdjcIIEMguIKCzb4D+CRAIKyCgw45GYQQIZBcQ0Nk3QP8ECIQVENBhR6MwAgSyCwjo7BugfwIEwgoI6LCjURgBAtkFBHT2DdA/AQJhBQR02NEojACB7AICOvsG6J8AgbACAjrsaBRGgEB2AQGdfQP0T4BAWAEBHXY0CiNAILuAgM6+AfonQCCsgIAOOxqFESCQXUBAZ98A/RMgEFZAQIcdjcIIEMguIKCzb4D+CRAIKyCgw45GYQQIZBcQ0Nk3QP8ECIQVENBhR6MwAgSyCwjo7BugfwIEwgoI6LCjURgBAtkFBHT2DdA/AQJhBQR02NEojACB7AICOvsG6J8AgbACAjrsaBRGgEB2AQGdfQP0T4BAWAEBHXY0CiNAILuAgM6+AfonQCCsgIAOOxqFESCQXUBAZ98A/RMgEFZAQIcdjcIIEMguIKCzb4D+CRAIKyCgw45GYQQIZBcQ0Nk34IH+564820w/9ZK9sBcEAgg4EAMMIUoJNZw7Y38q682J0nnyZbsRZTDqSCvgIEw7+vsbX/rtc8363NUy0blVlpfOlNHpS6XzxPfsh/0g0EcBB2Af8SO99NJ//3Mz1ly7W1LTOl/an/qp/Yg0JLWkE3AAphv5ww3XUxtTq78pzcTy3f+xtTxSVjoXnOqwHwT6KCCg+4gf4aVrOE+s/b60xt97qJyR5YmyMHahTH/6R/YkwrDUkE7AgZdu5B80vHD9+aa9eLWMbLy7rcLGyumyPPaJ4sqOxIui9b4JCOi+0ff3hes757HVN0p74s6uhdSQ3jjxKR8a7irlAQQOV0BAH67nQDxbvWKjmX+9p3DuNlQ/NFxanXG6YyAmrMhhERDQwzLJHvqopzRaC38oreWbW55z3ukp6oeGayOnysbEWR8c9mDtIQQOQ0BAH4Zi8OeYu/b9psz/qtQvoex0vrnXNlwn3auUxxE4mICAPpjfQPx1vca5WXq3lLG10h794FK6gxS/+eHh6Eec8jgIor8lsIuAgB7yFVm49t2mtfjLzS7rqY3RZvG+65330/7q+kTZWD1RNtrnSpl+pkxf/Lo92g+kvyEgoO1AFZh983IzdvtnpdcrN7ZT6152V05+RjBbLQJHLOCdzxEDR3r69/74s2b01uXSWnlr854be/m3unyirDfTpXX2UlluPV1mPv4Vu7MXQI8lsA8BB9k+0Ab9T7qnPep56V6ug679Lq5fcjpj0Aev/oETENADN7LDKbie8mhu/LhMjv55x5CuX/de7TxSVie/4JTG4dB7FgI9CwjonqmG74E1pNt/+WHpdLb+qnf3Xhw+CBy+2etoMAQE9GDM6ciqvPO7bzVl9hcPnZOuX0xZnzxXljpf8s75yPQ9MYGdBQS0DSlLb3yjWb/92n0hXa/WWJv5uzJ14UU7YkcI9EnAwdcn+GgvO/f6V5vJ0aubZdXrnNdGPukOdtGGpJ50AgI63ci3brh+Hby9+PPSrL1dxtozZf7E11xKZzcI9FlAQPd5AJFevnszpdX1D3n3HGkwakkrIKDTjn7rxuv56M7j37YX9oJAAAEHYoAhKIEAAQJbCQhoe0GAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQEBA2wECBAgEFRDQQQejLAIECAhoO0CAAIGgAgI66GCURYAAAQFtBwgQIBBUQEAHHYyyCBAgIKDtAAECBIIKCOigg1EWAQIEBLQdIECAQFABAR10MMoiQICAgLYDBAgQCCogoIMORlkECBAQ0HaAAAECQQUEdNDBKIsAAQIC2g4QIEAgqICADjoYZREgQOD/AU2asZbK9jJbAAAAAElFTkSuQmCC"
          />
        </defs>
      </svg>
      <vButton @click="connectWallet">
        <template v-if="downloadText">Download Metamask</template>
        <template>Connect Wallet</template>
      </vButton>
    </div>
  </Modal>
</template>

<script>
import axios from "axios";

import dapp from "../mixins/dapp";

import Modal from "./modal.vue";
import vButton from "../ui/v-button.vue";

const apiUrl = process.env.BASE_URL;

export default {
  mixins: [dapp],

  components: {
    Modal,
    vButton,
  },

  methods: {
    modalClose() {
      this.$emit("modalClose");
    },

    async connectWallet() {
      const token = localStorage.getItem("token");

      const { data } = await axios.get(
        `${apiUrl}/api/signatures/user_wallet_connection`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const routeName = "UserVerification";
      const routeQuery = {
        user_id: data.user_id,
        user_salt: data.user_salt,
        source: 0,
        prevUrl: this.$route.path,
      };

      if (this.isMobile) {
        this.openMetamask(routeName, routeQuery);

        return;
      }

      this.$router.push({
        name: routeName,
        query: routeQuery,
      });

      this.modalClose();
    },
  },
};
</script>

<style scoped>
.modal-inner {
  margin: 0 auto;
  max-width: 321px;
}

.modal-title {
  margin-bottom: 6px;
  color: #1e2541;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
}

@media (max-width: 767px) {
  .modal-title {
    font-size: 24px;
    line-height: 1;
  }
}

.modal-description {
  margin-bottom: 5px;
  color: #1e2541;
  line-height: 19px;
  text-align: center;
}

.modal-icon {
  display: block;
  margin: 0 auto 45px;
}

::v-deep .button {
  width: 100%;
}
</style>
